import Swiper from '//cdn.shopify.com/s/files/1/2068/9901/t/97/assets/swiper-bundle.esm.browser.min.js?v=91406107473600669311666097317 ';

    const blocks = document.querySelectorAll('.reviews-slider');
    let swiperCss = document.createElement('link');
    const swiperBeforeInit = function (el){
        el.classList.remove('slides');
        el.classList.add('swiper');
        el.style.position = 'relative';
        el.innerHTML = '<div class="swiper-wrapper">' + el.innerHTML + '</div>';
        el.querySelectorAll('.block').forEach((e) => e.classList.add('swiper-slide'));

        el.insertAdjacentHTML('beforeend', '<div class="slider-buttons" aria-hidden="true"><button type="button" data-role="none" class="slider-arrow prev" aria-label="Previous" role="button"></button>' +
            '<button type="button" data-role="none" class="slider-arrow next" aria-label="Next" role="button"></button></div><div class="swiper-pagination"></div>');
    }
    let loadcss = new Promise((resolve, reject) => {
        if (!document.swiper) {
            swiperCss.href = "//cdn.shopify.com/s/files/1/2068/9901/t/97/assets/swiper-bundle.css?v=84395560693144233261666083423";
            swiperCss.media = "all";
            swiperCss.rel = "stylesheet";
            swiperCss.type = "text/css";
            swiperCss.onload = function () {
                resolve();
                document.swiper = true;
            };
            document.head.appendChild(swiperCss);
        } else resolve();
    });

    blocks.forEach(function (el) {

        if(el.swiper)
            return;
        let productSwiper;
        const enableSwiper = function () {
            swiperBeforeInit(el);
            params.navigation = {
                nextEl: el.querySelector('.next'),
                prevEl: el.querySelector('.prev')
            };
            productSwiper = new Swiper(el, params);
        };
        let params = {
            loop: false,
            spaceBetween: 0,
            slidesPerView: 1,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'horizontal',
            breakpoints: {
                750: {
                    slidesPerView: 3,
                }
            },
            on: {
                beforeInit: function (swiper) {
                    el.classList.remove('row');
                }
            }
        };

        loadcss.then(function () {
            enableSwiper(el);
        });
    });
//}